import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadBuiManifestService } from './services/load-bui-manifest.service';
import { BuiClaimCardComponent } from './components/bui-claim-card/bui-claim-card.component';
import { BuiJobCardComponent } from './components/bui-job-card/bui-job-card.component';
import { BuiListJobCardComponent } from './components/bui-list-job-card/bui-list-job-card.component';
import { BuiListClaimCardComponent } from './components/bui-list-claim-card/bui-list-claim-card.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { RouterModule } from '@angular/router';
import { FLXDetailsComponent } from './views/details-view/details-view.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FLXListViewComponent } from './views/list-view/list-view.component';
import { BuiService, ClaimService, JobService } from './services';
import { UIElementsModule } from '@flexus/ui-elements';
import { ThemeModule } from '@flexus/ux';
import { BuiWorkflowShellComponent } from './base-components/bui-workflow-shell/bui-workflow-shell.component';
import { BuiFlowComponent } from './base-components/bui-flow/bui-flow.component';
import { environment } from '../../../environments/environment';
import { UICompositesModule } from '@flexus/ui-composites';
import { ErrorHandlerModule } from '@flexus/error-handler';
import { ScreensModule } from '@flexus/screens';
import { ActivateStateGuard } from './guards/activate-state.guard';
import { DeactivateStateGuard } from './guards/deactivate-state.guard';
import { SearchBannerModule } from '../../app-shell-features';
import { MsalModule } from '@azure/msal-angular';
import { PublicClientApplication } from '@azure/msal-browser';
import { DynamicLoaderModule } from '@flexus/engine';
import { IdentityModule } from '@flexus/identity';


export function loadConfig(manifest: LoadBuiManifestService) {
	return function () {
		return manifest.load();
	};
}

export function tokenGetter() {
	return localStorage.getItem('flexus.web.jwtToken');
}
@NgModule({
	imports: [
		CommonModule,
		...environment.appShellFeatures,
		DynamicLoaderModule,
		ErrorHandlerModule,
		ScreensModule,
		InlineSVGModule,
		NgxPaginationModule,
		RouterModule,
		ThemeModule,
		...environment.plugins['global'],
		UIElementsModule.forRoot({ environment: environment }),
		UICompositesModule,
		environment['azure']
			? MsalModule.forRoot(
					new PublicClientApplication({
						auth: {
							clientId: environment['azure']['clientId'],
							postLogoutRedirectUri: `${environment.base_url}auth/login`
						}
					}),
					null,
					null
			  )
			: CommonModule,
		IdentityModule.forRoot({
			after_login_url: '/workflow',
			after_logout_url: '/auth/login',
			send_reset_link_endpoint: `${environment.api_url}v1/forgot_password/check-email`,
			login_endpoint: `${environment.api_url}v2/auth/login/`,
			no_auth_urls: ['/cons']
		}),
		SearchBannerModule
	],
	declarations: [
		BuiClaimCardComponent,
		BuiListClaimCardComponent,
		BuiJobCardComponent,
		BuiListJobCardComponent,
		FLXDetailsComponent,
		FLXListViewComponent,
		BuiWorkflowShellComponent,
		BuiFlowComponent
	],
	exports: [
		...environment.appShellFeatures,
		BuiClaimCardComponent,
		BuiJobCardComponent,
		BuiListClaimCardComponent,
		BuiListJobCardComponent,
		FLXDetailsComponent,
		FLXListViewComponent
	],
	providers: [
		ActivateStateGuard,
		DeactivateStateGuard,
		BuiService,
		ClaimService,
		JobService,
		{
			provide: APP_INITIALIZER,
			useFactory: loadConfig,
			deps: [LoadBuiManifestService],
			multi: true
		}
	]
})
export class BuiManifestModule {}
